import {
  DirectoryTypeConsts,
  ItemTypeConsts,
  ItemTypeRoutes,
  getDetailsRoute,
} from 'client/util/Constants';

export default {
  methods: {
    activeDirectoryDetailsRoute(id) {
      return this.directoryTypeAsideRoute(ItemTypeConsts.activeDirectory, id);
    },

    directoryType(type) {
      let directoryType = type;

      if (type === DirectoryTypeConsts.gSuite || type === DirectoryTypeConsts.office365) {
        directoryType = ItemTypeConsts.cloudDirectory;
      }
      if (type === DirectoryTypeConsts.workday) {
        directoryType = ItemTypeConsts.hrDirectory;
      }
      if (type === DirectoryTypeConsts.activeDirectory) {
        directoryType = ItemTypeConsts.activeDirectory;
      }

      return directoryType;
    },

    directoryTypeRoute(type) {
      return ItemTypeRoutes[this.directoryType(type)];
    },

    directoryTypeAsideRoute(type, id) {
      if (id) {
        return getDetailsRoute(type, { id });
      }

      return `${this.directoryTypeRoute(type)}/${type}/new`;
    },
  },
};
